import { render, staticRenderFns } from "./CartaoObservacoesGerais.vue?vue&type=template&id=725337ad&scoped=true"
import script from "./CartaoObservacoesGerais.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoObservacoesGerais.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoObservacoesGerais.vue?vue&type=style&index=0&id=725337ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725337ad",
  null
  
)

export default component.exports